<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="案件来源:" >
                        <el-select v-model="queryParams.ajly" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in ajlyOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="当事人:" prop="dwmc">
                        <el-input
                        v-model="queryParams.dwmc"
                        placeholder="请输入当事人"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="立案日期:" >
                        <el-date-picker size="small" clearable
                            v-model="queryParams.startDate"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        至
                        <el-date-picker size="small" clearable
                            v-model="queryParams.endDate"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="创建人:" prop="cjr">
                        <el-select v-model="queryParams.cjr" placeholder="请选择创建人" size="small" style="width:120px;">
                            <el-option
                            v-for="(dict,index) in userOptions"
                                :key="index"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审批状态:" prop="spzt">
                        <el-select v-model="queryParams.spzt" placeholder="请选择" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in spztOptions"
                                :key="dict.id"
                                :label="dict.city"
                                :value="dict.city"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上传状态:" prop="sczt">
                        <el-select v-model="queryParams.sczt" placeholder="请选择" size="small" style="width:120px;">
                            <el-option
                                v-for="dict in scztOptions"
                                :key="dict.id"
                                :label="dict.city"
                                :value="dict.city"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
                <p>案件数量:{{total}} </p>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="ajslList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="决定书文号" align="center" prop="jdswh" />
                    <el-table-column label="唯一id" align="center" prop="id" />
                    <el-table-column label="监督对象名称" prop="dwmc" />
                    <el-table-column label="专业类别" align="center" prop="zylb" />
                    <el-table-column label="立案日期" align="center" prop="larq" />
                    <el-table-column label="上报日期" align="center" prop="zbr" />
                    <el-table-column label="上传状态" align="center" prop="xbr" />
                    <el-table-column label="创建者" align="center" prop="xbr" />
                    <el-table-column label="案由" prop="anyou" />
                    <el-table-column label="状态" align="center" prop="tbzt" />
                    <el-table-column label="查看" align="center">
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleSelect(scope.row)"
                        >查看</el-button>
                        </template>
                    </el-table-column>
                    
                    <!-- <el-table-column label="打印" align="center" class-name="small-padding fixed-width" width="220" >
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleSelect(scope.row)"
                        >打印</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            queryParams:{
                dwmc:'',
                ajly:'',
                larq:'',
                cjr:'',
                spzt:'',
                sczt:'',
                page:1,
                limit:10,
            },
            total:0,
            ajslList:[],
            ajlyOptions:[],
            userOptions:[],
            spztOptions:[],
            scztOptions:[],
            open:false,
            pageshow:true,
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList(){
            this.ajslList = []
            this.total = 0
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){},
        getCheck(){
            console.log(this.checkList)
        },
        handleSelect(row){
            this.$router.push({path:'/daxq',query:{id:row.id}})
        },
        resetQuery(){
            this.queryParams = {
                dwmc:'',
                ajly:'',
                larq:'',
                cjr:'',
                spzt:'',
                sczt:'',
                page:1,
                limit:10,
            }
            this.getList()
        }
    }
}
</script>


<style scoped>
</style>